import { Account, AccountNextStep } from "@/types";
import { isQuilter } from "./service-provider-helpers";
import { readableAccountType } from "@/utils/accounts";

export function dealWithQuilter(
  isQuitler: boolean,
  account: ReadonlyArray<Account> | Account | undefined | null,
  dispatch: any
) {
  account ??= [];
  let accounts: ReadonlyArray<Account> = [];
  if (!isQuitler) return;
  if (!Array.isArray(account)) accounts = [account as Account];
  else {
    accounts = [...account];
  }

  dispatch({
    type: "SET_QUILTER_ACCOUNT_INFO",
    payload: expressQuilterState(accounts),
  });
}

function expressQuilterState(accounts: ReadonlyArray<Account>) {
  let quilterThresholdReached = false;
  let withdrawal = false;
  let isPlaceOfDeathUk = true;

  if (accounts && accounts.length !== 0) {
    for (const account of accounts) {
      // isQuilter(...) is assumed to be a function checking account details
      quilterThresholdReached = quilterThresholdReached || !!account.assetsValueAboveThreshold;
      withdrawal =
        withdrawal || account.nextSteps === AccountNextStep.WithdrawalOfFundsToExecutorAccount;
      if (account.isPlaceOfDeathUk !== undefined) {
        isPlaceOfDeathUk = account.isPlaceOfDeathUk;
      }
    }
  }
  return {
    quilterThresholdReached,
    [AccountNextStep.WithdrawalOfFundsToExecutorAccount]: withdrawal,
    isPlaceOfDeathUk,
  };
}

export function accountTitle(account: Account) {
  let accountName = account.companyName;
  if (isQuilter(account.companyId)) {
    accountName = accountName + " " + readableAccountType(account.accountType);
  }
  return accountName;
}

export const getAccountCount = (accounts: any) => {
  let count = 0;
  accounts.forEach((account: any) => {
    if (
      account.additionalServicesAccount === false ||
      account.serviceProviderType.localeCompare("affiliate_partner") != 0
    ) {
      count++;
    }
  });
  return count;
};
